// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"611":"0c096e17","661":"2b26355c"}[chunkId] + ".chunk.js";
};